import { Order, OrderGoods, OrderGoodsADR, UpdateOrderGoodsPaylod } from "../../../../api/types/order"
import { FormErrorsArr } from "../../../FieldError"

export const validateGoods = (data: UpdateOrderGoodsPaylod, orderDetail: Order):
  [boolean, FormErrorsArr<OrderGoods>, FormErrorsArr<OrderGoods>[]] => {
  let isValid: boolean = true;
  let errors: FormErrorsArr<OrderGoods> = []
  let goodsADRErrors: FormErrorsArr<OrderGoodsADR>[] = []

  const { goods } = data

  goods.forEach((good: OrderGoods, index: number) => {
    errors.push({})

    if (!good.content) {
      errors[index].content = "Název zboží je povinné pole."
      isValid = false
    }

    if (!good.pieces) {
      errors[index].pieces = "Počet kusů je povinné pole."
      isValid = false
    }

    if (!good.weight) {
      errors[index].weight = "Hmotnost je povinné pole."
      isValid = false
    }

    if (!good.packing) {
      errors[index].packing = "Obal je povinné pole."
      isValid = false
    }

    if (!good.length) {
      errors[index].length = "Délka je povinné pole."
      isValid = false
    }

    if (!good.width) {
      errors[index].width = "Šířka je povinné pole."
      isValid = false
    }

    if (!good.height) {
      errors[index].height = "Výška je povinné pole."
      isValid = false
    }

    // -ADR----------------------------------------------------------------------------

    let goodADR: FormErrorsArr<OrderGoodsADR> = []

    good.adr.forEach((adr: OrderGoodsADR, gIndex: number) => {
      goodADR.push({})

      if (!adr.codeUN) {
        goodADR[gIndex].codeUN = "UN kód je povinné pole."
        isValid = false
      }

      if (!adr.pieces) {
        goodADR[gIndex].pieces = "Počet kusů je povinné pole."
        isValid = false
      }

      if (!adr.brutto) {
        goodADR[gIndex].brutto = "Brutto je povinné pole."
        isValid = false
      }

      if (!adr.netto) {
        goodADR[gIndex].netto = "Netto je povinné pole."
        isValid = false
      }

      if (!adr.technicalName) {
        goodADR[gIndex].technicalName = "Technický název je povinné pole."
        isValid = false
      }

      if (
        (orderDetail.loading?.country !== "CZ" || orderDetail.unloading?.country !== "CZ")
        && !adr.technicalNameEN
      ) {
        goodADR[gIndex].technicalNameEN = "Technický název anglicky je povinné pole."
        isValid = false
      }
    })

    goodsADRErrors.push(goodADR)
  })

  return [isValid, errors, goodsADRErrors]
}
